// Fired on window when stock changes outside the Inventory page itself (the header's
// low-stock alerts restocking a product), so an open Inventory page refetches.
export const INVENTORY_CHANGED_EVENT = "inventory:changed";
